import { createContext, useContext, useEffect, useState } from "react";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const Ctx = createContext({});

const readCache = () => {
  try {
    return JSON.parse(localStorage.getItem("ap_settings") || "{}");
  } catch {
    return {};
  }
};

export const SettingsProvider = ({ children }) => {
  const [settings, setSettings] = useState(readCache);
  useEffect(() => {
    axios
      .get(`${API}/settings`)
      .then((r) => {
        setSettings(r.data);
        localStorage.setItem("ap_settings", JSON.stringify(r.data));
      })
      .catch(() => {});
  }, []);
  return <Ctx.Provider value={settings}>{children}</Ctx.Provider>;
};

export const useSettings = () => useContext(Ctx);
